import React from "react";

export const AVAILABILITY_OPTIONS = [
  { value: "mañanas", label: "Mañanas" },
  { value: "tardes", label: "Tardes" },
  { value: "entre_semana", label: "Entre semana" },
  { value: "fin_de_semana", label: "Fin de semana" },
];

export const LANGUAGE_OPTIONS = ["Español", "Inglés", "Francés"];

export const SUBJECTS_TREE = {
  "Refuerzo escolar": ["Matemáticas", "Lengua", "Ciencias", "Todas"],
  "Idiomas": ["Inglés", "Francés", "Otros"],
  "Tecnología": ["Programación", "Robótica", "Ofimática"],
  "Creatividad": ["Arte", "Música", "Manualidades"],
  "Apoyo y desarrollo": ["Técnicas de estudio", "Logopedia", "Coaching"],
  "Otros": ["Otros"],
};
